import { createStore, applyMiddleware, compose } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import createTransform from "redux-persist/es/createTransform";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import allReducers from "./reducers";
import { documentJobsSyncMiddleware, setupDocumentJobsSyncListener } from "./middlewares/documentJobsSync";

const documentJobsTransform = createTransform(
    (inboundState) => ({
        userPreference: inboundState.userPreference,
    }),
    (outboundState) => ({
        jobs: [],
        open: true,
        visible: false,
        modalJobId: null,
        userPreference: {
            openInBrowserWhenReady: false,
            ...(outboundState?.userPreference || {}),
        },
    }),
    { whitelist: ['documentJobs'] }
);

const persistConfig = {
    key: "root",
    storage: storage,
    stateReconciler: autoMergeLevel2,
    transforms: [documentJobsTransform],
};

const pReducer = persistReducer(persistConfig, allReducers);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
    pReducer,
    composeEnhancers(applyMiddleware(documentJobsSyncMiddleware))
);

setupDocumentJobsSyncListener(store);

export const persistor = persistStore(store);
